// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { useProfile } from '@cash-web/shared-auth-data-access-api'

import { useLogCashWebCdfEvent } from './useLogCashWebCdfEvent'

/*
 * This hook wraps useLogCashWebCdfEvent in order to pass the customer_token
 * with the CDF event for authenticated apps. Apps must be wrapped in <QueryClientProvider />
 * in order to use this hook.
 */
export function useLogAuthedCashWebCdfEvent(hostName?: string) {
  const { data } = useProfile()
  const customerToken = data?.profile?.customer_token

  return useLogCashWebCdfEvent({ hostName, customerToken })
}
